import React, { memo, useState } from 'react';
import './index.scss';

const Radio = memo((props) => {
  const {
    label,
    // value,
    // currentType,
    changeType
  } = props;

  const [isSelected, setSelect] = useState(false);

  const handleChangeType = () => {
    setSelect(!isSelected);
    changeType(label, !isSelected);
  };

  return (
    <div className="radio-tab" onClick={handleChangeType}>
      <div className={isSelected ? 'radio-icon active' : 'radio-icon'}>{label}</div>
    </div>
  );
});

export default Radio;
